module.exports = __webpack_public_path__ + "img/Picture18.3588e79c.png";